<template>
  <div>

    <div> <h5 class="alert alert-success center-align">Add Publication</h5> </div>
    <div class="row">
      <form class="col s12" v-if="!submitted">
        <div class="row">
          <div class="input-field col s12">
            <i class="material-icons prefix">title</i>
           <input v-model="publications.title" placeholder="Title of your Research" id="title" type="text" class="validate">
          <label for="title">Title</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <i class="material-icons prefix">mode_edit</i>
            <textarea v-model="publications.abstract" id="abstract" class="materialize-textarea"></textarea>
            <label for="abstract">Abstract of the Research</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <i class="material-icons prefix">insert_link</i>
            <input v-model="publications.flink" id="flink" type="url" class="validate">
            <label for="flink">Link of your file</label>
          </div>
        </div>

        <!-- <div class="input-field col s12">
          <i class="material-icons prefix">domain</i>
          <select v-model="publications.category">
            <option value="" disabled selected>Choose a Category</option>
            <option value="1">Artificial Intelligence </option>
            <option value="1">Machine Learning</option>
            <option value="1">Deep Learning</option>
            <option value="1">Software Engineering</option>
            <option value="1">Other fields</option>
          </select>
          <label>Category</label>
        </div> -->

        <div class="row">
          
          <a class="waves-effect waves-light btn-large" v-on:click.prevent='postData' >Add Publication</a>
          <!-- <button class="btn waves-effect waves-light" type="button" name="action">Submit
          <i class="material-icons right">send</i>
          </button> -->

        </div>
      </form>
      <div>{{publications.abstract}}</div>
      <div v-if="submitted" class="light-green lighten-2 repmsg">
        <p>Your form has been successfully submitted</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name:'myLovelyInsertPub',
  data(){
    return { 
      publications: {
          category:'',
          title:'',
          abstract:'',
          flink:''
        },
        submitted:false
    }
  },
  methods:{
    postData:function(){
      this.$http.post('https://sehidb8.firebaseapp.com/apps',{
        title: this.publications.title,
        abstract: this.publications.abstract,
        link: this.publications.flink
      }).then(function(){
        this.submitted =true;
      });
    }
  }
}
</script>
<style scoped>
h5 {
  padding: 16px;
  border-radius: 2px;
}
.ppad{
  padding: 1%;
}
  .repmsg{
  padding: 8px;
  text-align: center;
  }
</style>
